<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {
    var url =
      "https://s.kakayuy.net/ws/atad/index.html#/KBTZ?u=" +
      this.$route.query.u +
      "&r=" +
      this.$route.query.r;
    url = encodeURIComponent(url);
    window.location.href =
      "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx413c22b25bef73ab&redirect_uri=" +
      url +
      "&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect";
  },
  methods: {},
};

</script>

<style lang="less" scoped>
</style>

